/*
 * The ability to take a new exposure should be disabled if it can be deduced with certainty
 * that the resulting observation will not be successful. The cases that should disable a
 * new observation in the RTI are as follows:
 *
 *    - The weather is bad.
 *    - The sun is up.
 *    - The session is not active.
 *    - The instrument or telescope are in a bad state.
 *
 * There should be feedback that describes the underlying reason why a new observation is disabled.
 */
import { cameraStates, progressStates, siteStates } from './common';

function getButtonState(status, sessionActive) {
  let feedback = '';

  if (!status.availability || !status.progress) {
    feedback = 'Session data is unavailable.';
  }
  else if (!sessionActive) {
    feedback = 'The session is not currently active';
  }
  else if (status.availability !== siteStates.AVAILABLE) {
    feedback = 'The site is not currently available for observations: ' + status.availability;
  }
  else if (status.progress === progressStates.PROCESSING || status.progress === progressStates.EXECUTING) {
    feedback = 'You can click here to abort your observation.';
  }
  else if (status.instrument !== cameraStates.IDLE) {
    feedback = 'The camera is not ready for a new observation.';
  }
  else if (status.progress === progressStates.READY || status.progress === progressStates.ERROR) {
    feedback = '';
  }
  return {
    'feedback': feedback
  };
}

export {
  getButtonState
};
